// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"bannerWrapper__32yBA","unifiedNav":"unifiedNav__ztrQz"};